import React, { useRef, useState, useEffect } from 'react'
import useStore from '@/store'
import classNames from 'classnames'
import type { Props } from './types'
import Label from '@/components/label'
import LocationModalContent from '@/components/modal/location-modal-content'
import styles from './style.module.scss'

const Location: React.FC<Props> = ({
  data,
  isActive,
  isFiltered,
  isResident,
}) => {
  const setModal = useStore((state) => state.setModal)
  const position = data.attributes.Position
  const category = data.attributes.Category
  const sounds = useStore((state) => state.sounds)
  const [showLabel, setShowLabel] = useState(false)
  const labelTimerRef = useRef<NodeJS.Timeout | null>(null)
  const classes = classNames(
    styles['location'],
    [[`type--${category.data.attributes.Slug}`]],
    {
      [styles['is-mirrorred']]: data.attributes.Position?.Mirrored,
      [styles['is-filtered']]: isFiltered,
      [styles['is-resident']]: isResident,
      [styles['is-switzerland']]:
        data.attributes.Position?.Map === 'Switzerland',
    }
  )

  useEffect(() => {
    setShowLabel(false)
  }, [isFiltered, isActive])

  function handleClick() {
    if (isResident) return false
    if (data.attributes.NonInteractive) {
      setShowLabel(true)
      if (labelTimerRef.current) clearTimeout(labelTimerRef.current)
      labelTimerRef.current = setTimeout(() => setShowLabel(false), 3000)
      return false
    }
    sounds?.click2?.play()
    const side = data.attributes.Position?.Mirrored ? 'top' : 'bottom'
    setModal(
      {
        content: (
          <LocationModalContent
            title={data.attributes.Title}
            text={data.attributes.Data.Text}
            image={data.attributes.Data.Image?.Image}
            caption={data.attributes.Data.Image?.Caption}
          />
        ),
        type: 'location',
        closeAction: () =>
          setModal({ content: undefined, type: 'location' }, side),
      },
      side
    )
  }

  return (
    <div
      className={classes}
      style={
        !isResident
          ? {
              top: `${position?.Y}%`,
              left: `${position?.X}%`,
            }
          : undefined
      }
    >
      {!isResident && (
        <Label
          text={data.attributes.Label}
          placement={data.attributes.LabelPlacement}
          hidden={!isActive && !showLabel}
          clickHandler={() => handleClick()}
        />
      )}
      <button
        className={styles.button}
        style={
          data.attributes.NonInteractive
            ? {
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                outline: `0.6rem solid ${category.data.attributes.Color}`,
                outlineOffset: '-0.6rem',
                opacity: 0.85,
              }
            : { backgroundColor: category.data.attributes.Color }
        }
        onClick={() => handleClick()}
      />
    </div>
  )
}

export default React.memo(Location)
